import {
  fetchCatBrandStart,
  fetchCatBrandSuccess,
  fetchCatBrandFailure,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_BRAND_BY_CATEGORY } from "../../constants/constants";

export const getCatBrand =
  (categories, setLoading) => async (dispatch) => {
    try {
      setLoading(true);

      dispatch(fetchCatBrandStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_BRAND_BY_CATEGORY(categories),
        "GET"
      );

      setLoading(false);

      dispatch(fetchCatBrandSuccess(response));
    } catch (error) {
      setLoading(false);

      dispatch(fetchCatBrandFailure(error.message));
    }
  };